export default {

  prevPage(event) {
    event?.preventDefault()
    if (this.currentPageValue > 0) {
      this.currentPageValue--
      this.loadLineSuggestions('Loading previous page...')
    }
  },

  nextPage(event) {
    event?.preventDefault()
    if ((this.currentPageValue + 1) * this.linesPerPageValue < this.totalLinesValue) {
      this.currentPageValue++
      this.loadLineSuggestions('Loading next page...')
    }
  },

  goToPage(event) {
    event?.preventDefault()
    const page = parseInt(event.target.dataset.page)
    if (!isNaN(page) && page >= 0 && page < this.totalPages) {
      this.currentPageValue = page
      this.loadLineSuggestions(`Loading page ${page + 1}...`)
    }
  },

  buildPageParam() {
    return {
      number: this.currentPageValue + 1,
      size: this.linesPerPageValue
    }
  },

  onPageSizeChange() {
    if (this.hasPageSizeSelectTarget) {
      this.linesPerPageValue = parseInt(this.pageSizeSelectTarget.value) || 100
      this.currentPageValue = 0
      this.loadLineSuggestions('Updating page size...')
    }
  },

  renderPaginationControls() {
    if (!this.hasPaginationTopTarget) return

    const totalPages = this.totalPages
    const currentPage = this.currentPageValue

    if (totalPages <= 1) {
      this.paginationTopTarget.innerHTML = ''
      this.paginationTopTarget.classList.add('hidden')
      if (this.hasPageSizeContainerTarget) {
        this.pageSizeContainerTarget.classList.add('hidden')
      }
      this.adjustTableHeight(false)
      return
    }

    this.paginationTopTarget.classList.remove('hidden')
    if (this.hasPageSizeContainerTarget) {
      this.pageSizeContainerTarget.classList.remove('hidden')
    }
    this.adjustTableHeight(true)

    this.paginationTopTarget.innerHTML = this._buildPaginationHTML(totalPages, currentPage)
  },

  adjustTableHeight(hasPagination) {
    if (!this.hasTableContainerTarget) return

    const heightFor10Rows = 540
    const newHeight = heightFor10Rows
    const container = this.tableContainerTarget
    const scrollContainer = container.querySelector('div[style*="overflow-y"]')

    if (container) {
      container.style.maxHeight = `${newHeight}px`
    }

    if (scrollContainer) {
      scrollContainer.style.maxHeight = `${newHeight}px`
    }
  },

  _buildPaginationHTML(totalPages, currentPage) {
    const showingStart = currentPage * this.linesPerPageValue + 1
    const showingEnd = Math.min((currentPage + 1) * this.linesPerPageValue, this.totalLinesValue)

    let html = `
      <nav aria-label="Page navigation">
        <div class="row">
          <div class="col-sm-6">
            <p class="text-muted">
              Showing ${showingStart} to ${showingEnd}
              of ${this.formatNumber(this.totalLinesValue)} entries
            </p>
          </div>
          <div class="col-sm-6">
            <ul class="pagination pagination-sm pull-right" style="margin: 0;">
    `

    html += this._buildPreviousButton(currentPage)
    html += this._buildPageButtons(totalPages, currentPage)
    html += this._buildNextButton(currentPage, totalPages)

    html += `
            </ul>
          </div>
        </div>
      </nav>
    `

    return html
  },

  _buildPreviousButton(currentPage) {
    const disabled = currentPage === 0
    return `
      <li ${disabled ? 'class="disabled"' : ''}>
        <a data-action="click->add-line-modal#prevPage" href="#" ${disabled ? 'tabindex="-1"' : ''}>
          &laquo; Previous
        </a>
      </li>
    `
  },

  _buildPageButtons(totalPages, currentPage) {
    let html = ''
    let startPage = Math.max(0, currentPage - 2)
    let endPage = Math.min(totalPages - 1, currentPage + 2)

    if (startPage > 0) {
      html += `<li><a data-action="click->add-line-modal#goToPage" data-page="0" href="#">1</a></li>`
      if (startPage > 1) {
        html += `<li class="disabled"><span>...</span></li>`
      }
    }

    for (let page = startPage; page <= endPage; page++) {
      html += `
        <li ${page === currentPage ? 'class="active"' : ''}>
          <a data-action="click->add-line-modal#goToPage" data-page="${page}" href="#">
            ${page + 1}
          </a>
        </li>
      `
    }

    if (endPage < totalPages - 1) {
      if (endPage < totalPages - 2) {
        html += `<li class="disabled"><span>...</span></li>`
      }
      html += `<li><a data-action="click->add-line-modal#goToPage" data-page="${totalPages - 1}" href="#">${totalPages}</a></li>`
    }

    return html
  },

  _buildNextButton(currentPage, totalPages) {
    const disabled = currentPage >= totalPages - 1
    return `
      <li ${disabled ? 'class="disabled"' : ''}>
        <a data-action="click->add-line-modal#nextPage" href="#" ${disabled ? 'tabindex="-1"' : ''}>
          Next &raquo;
        </a>
      </li>
    `
  },

}
